var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17188 7.44141L12.0019 12.5514L20.7719 7.47141",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6091V12.5391",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93062 2.48126L4.59063 5.44126C3.38063 6.11126 2.39062 7.79126 2.39062 9.17126V14.8213C2.39062 16.2013 3.38063 17.8813 4.59063 18.5513L9.93062 21.5213C11.0706 22.1513 12.9406 22.1513 14.0806 21.5213L19.4206 18.5513C20.6306 17.8813 21.6206 16.2013 21.6206 14.8213V9.17126C21.6206 7.79126 20.6306 6.11126 19.4206 5.44126L14.0806 2.47126C12.9306 1.84126 11.0706 1.84126 9.93062 2.48126Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery1);
export default __webpack_public_path__ + "static/media/Delivery (1).48cc7d416523271f3b9227a3019bc0e9.svg";
export { ForwardRef as ReactComponent };